import React, { useEffect } from "react";

import Main from '../components/Home/Main'
import Detailed from "../components/Home/Detailed";
import Features from "../components/Home/Features";
import HowDoes from "../components/Home/HowDoes";
import Exposing from "../components/Home/Exposing";
import Conclusion from "../components/Home/Conclusion";

function Home () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div>
            <Main/>
            <Detailed/>
            <Features/>
            <HowDoes/>
            <Exposing/>
            <Conclusion/>
        </div>
    );
}

export default Home;